'use client'
import * as React from 'react'
import { useTranslations } from 'next-intl'

import { NotEnoughCoinsDialogProvider } from '@repo/web-ui/ask-cf/contexts/not-enough-coins-dialog-context'
import { SocialShareDialogProvider } from '@repo/web-ui/ask-cf/contexts/social-share-dialog-context'
import { DeleteDialogProvider } from '@web/app/[locale]/(web)/masterfeed/contexts/delete-dialog-context'
import { AskCfTranslationProvider } from '@repo/web-ui/ask-cf/contexts/ask-cf-translation-context'
import { FollowersDialogProvider } from '../contexts/followers-dialog-context'
import { FeaturedImagesDialogProvider } from '../contexts/featured-images-dialog-context'
import { CreatePostProjectDialogProvider } from '@web/app/[locale]/(web)/masterfeed/_components/create-post-project-dialog/create-post-project-dialog-context'
import { ProjectDraftProvider } from '@web/app/[locale]/(web)/masterfeed/_components/create-post-project-dialog/project-draft-context'
import { FeedRouteProvider } from '@web/app/[locale]/(web)/masterfeed/contexts/feed-route-context'

export function Providers({ children }: React.PropsWithChildren) {
  const t = useTranslations('pages.clubhouse.ask_cf')

  return (
    <FeedRouteProvider basePath="/feed">
      <ProjectDraftProvider>
        <SocialShareDialogProvider>
          <DeleteDialogProvider>
            <NotEnoughCoinsDialogProvider>
              <FollowersDialogProvider>
                <FeaturedImagesDialogProvider>
                  <CreatePostProjectDialogProvider>
                    <AskCfTranslationProvider i18n={t}>{children}</AskCfTranslationProvider>
                  </CreatePostProjectDialogProvider>
                </FeaturedImagesDialogProvider>
              </FollowersDialogProvider>
            </NotEnoughCoinsDialogProvider>
          </DeleteDialogProvider>
        </SocialShareDialogProvider>
      </ProjectDraftProvider>
    </FeedRouteProvider>
  )
}
